import React from 'react';
import RawHtml from '../RawHtml';
import { TableCell } from './Table.styled';

const TableCellComponent = ({
  cellValue,
  cellClassName,
  style,
  colspan,
  rowspan,
}) => (
  <TableCell
    className={cellClassName}
    style={style}
    colSpan={colspan || 1}
    rowSpan={rowspan || 1}
  >
    <RawHtml
      className='styled-content'
      html={Object.entries(cellValue).length ? cellValue : ' '}
      style={{ display: 'inline', whiteSpace: 'pre-wrap' }}
    />
  </TableCell>
);

export default TableCellComponent;
